// extracted by mini-css-extract-plugin
export default {"container":"d1-z","heading":"e1-z","links":"f1-z","copy":"g1-z","subCopy":"h1-z","linksLeft":"i1-z","linksCenter":"j1-z","linksRight":"k1-z","link":"l1-z","onlyLink":"m1-z"};